import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { generateKit } from '../../../actions/coachCertificationActions'
import { showGenericError } from '../../../utility/helperFunctions'
import { certificationPath, isKitLoading } from '../../../utility/coachCertification'
import { COMMUNITY_REQUEST_FORM_URL } from '../../../misc/Constants'
import { stockAccolades } from '../../../accolades/accolades'
import { hasCommunity } from '../../../utility/userHelper'
import Button from './Button'

import classes from './Celebration.module.scss'
import buttonClasses from './Button.module.scss'

const Celebration = ({ certification, score, onClose }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const user = useSelector(state => state.user.current_user)
  const kitStatus = useSelector(state => state.coachCertification.kitStatus)
  const { enrollment } = certification
  const withCommunity = hasCommunity(user)
  const addedToKey = withCommunity ? 'addedToValue' : 'addedToValueNoCommunity'
  const kitLoading = isKitLoading(enrollment, kitStatus)

  return (
    <div className={classNames('d-flex align-items-center justify-content-center', classes.screen)}>
      <div className={classNames('position-relative text-center', classes.inner)}>
        <div className={classNames('position-relative mx-auto', classes.badgeWrapper)}>
          <div className={classes.ring} />
          <div className={classNames('d-flex align-items-center justify-content-center', classes.badge)}>
            <img src={stockAccolades.Certified.badge} alt='' className={classes.badgeImage} />
          </div>
        </div>
        <span className={classes.eyebrow}>{t('portal.certification.celebration.eyebrow', { score })}</span>
        <h1 className={classes.title}>{t('portal.certification.celebration.title', { level: certification.level, name: user?.first_name })}</h1>
        <p className={classes.body}>{t('portal.certification.celebration.body')}</p>
        <div className={classNames('text-left', classes.facts)}>
          <div>
            <span className={classes.factLabel}>{t('portal.certification.celebration.addedTo')}</span>
            <span className={classes.factText}>{t(`portal.certification.celebration.${addedToKey}`)}</span>
          </div>
          <div>
            <span className={classes.factLabel}>{t('portal.certification.celebration.certificate')}</span>
            <span className={classes.factText}>
              {t(`portal.certification.celebration.${enrollment.kitReady ? 'emailedTo' : 'willEmail'}`, { email: user?.email })}
            </span>
          </div>
        </div>
        <div className={classNames('d-flex align-items-center justify-content-center flex-wrap', classes.actions)}>
          {enrollment.kitReady
            ? (
              <Link
                to={`${certificationPath(certification.id)}#share`}
                className={classNames('btn btn-primary text-white', buttonClasses.primary)}
                onClick={onClose}
              >
                {t('portal.certification.celebration.viewKit')}
              </Link>
            )
            : (
              <Button loading={kitLoading} onClick={() => dispatch(generateKit(enrollment.id)).unwrap().catch(showGenericError)}>
                {t(`portal.certification.celebration.${kitLoading ? 'preparingKit' : 'generateKit'}`)}
              </Button>
            )}
          <Link to='/portal' className={classes.outlineButton} onClick={onClose}>{t('portal.certification.celebration.home')}</Link>
        </div>
        <p className={classNames('d-flex justify-content-center mt-4 mb-0', classes.links)}>
          {withCommunity
            ? <Link to='/dashboard' className={classes.review} onClick={onClose}>{t('portal.allSet.communityDashboard')}</Link>
            : (
              <a href={COMMUNITY_REQUEST_FORM_URL} target='_blank' rel='noopener noreferrer' className={classes.review}>
                {t('portal.allSet.requestAccess')}
              </a>
            )}
          <button type='button' className={classes.review} onClick={onClose}>{t('portal.certification.celebration.review')}</button>
        </p>
      </div>
    </div>
  )
}

Celebration.propTypes = {
  certification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    level: PropTypes.number.isRequired,
    enrollment: PropTypes.shape({ id: PropTypes.number.isRequired, kitReady: PropTypes.bool }).isRequired,
  }).isRequired,
  score: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default Celebration
